// BatSeqMasterCache.js
//
// Sequence masters per rk, did = battery rk.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'BatSeqMasterCache';

class BatSeqMasterCache extends CacheBase2 {
    _name = _name;

    /**
     * Masters of one battery, sorted by name.
     * @param {string} did - battery rk
     * @returns {object[]}
     */
    byDid = (did) => {
        const items = this.getAll().filter((m) => m.did === did);
        return items.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    };
}

const batSeqMasterCache = new BatSeqMasterCache();
export default batSeqMasterCache;
